import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("6px"),
    ...shorthands.padding("0px", "0px", "16px", "0px"),
  },
  field: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding(tokens.spacingHorizontalMNudge),
    width: "auto",
  },
  image: {
    ...shorthands.padding("0px", "6px", "0px", "0px"),
    width: "30px",
    height: "20px",
  },
  error: {
    color: tokens.colorPaletteRedForeground1,
    ...shorthands.padding("2px", "0px", "0px", "0px"),
    fontSize: tokens.fontSizeBase100,
  },
});
